import React, { useState, useRef } from "react";

interface VideoPlayerProps {
  coverImage?: string;
  videoUrl: string;
}

const VideoPlayer = ({ coverImage, videoUrl }: VideoPlayerProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlay = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsPlaying(true);
  };

  const handleStop = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsPlaying(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };
  // className="absolute inset-0 object-cover w-full h-full"
  return (
    <div className="w-full max-w-md mx-auto">
      {/* {!isPlaying ? (
        <div className="relative flex items-center w-full overflow-hidden bg-gray-200 h-200 max-h-200">
          {coverImage && <img src={coverImage} alt="Cover" className="object-cover h-full " />}
          <button
            className="absolute inset-0 flex items-center justify-center w-4 h-4 text-sm text-white bg-black bg-opacity-50"
            onClick={handlePlay}
          >
            ▶
          </button>
        </div>
      ) : ( */}
      <div className="relative">
        <video
          ref={videoRef}
          className="w-full h-auto"
          controls
          autoPlay={false}
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* )} */}
    </div>
  );
};

export default VideoPlayer;
